import { observable, action, makeObservable } from 'mobx';

type NotificationTheme = 'success' | 'error';

interface NotificationOpenParams {
  content: string;
  theme?: NotificationTheme;
}

export class NotificationStore {
  public isOpen: boolean = false;
  public theme?: NotificationTheme;
  public content?: string;

  constructor() {
    makeObservable(this, {
      isOpen: observable,
      theme: observable,
      content: observable,
      open: action.bound,
      close: action.bound,
    });
  }

  public open({ content, theme = 'success' }: NotificationOpenParams) {
    this.content = content;
    this.theme = theme;
    this.isOpen = true;
  }

  public close() {
    this.isOpen = false;
    this.content = undefined;
    this.theme = undefined;
  }
}
